import React, { useState } from "react";
import "../assets/css/premium.css";
import WhatsAppModal from "./MyWhatsAppModal";
import { Dialog, DialogContent, IconButton, Radio } from "@mui/material";

// Define categoryData as an empty array
const categoryData = [
  {
    id: "showEssential",
    label: "Service Home",
    items: [
      {
        id: 1,
        label: "Fashion",
        imageUrl: require("../assets/images/header_icons/menu-1.png"),
      },
      {
        id: 2,
        label: "Electronics",
        imageUrl: require("../assets/images/header_icons/menu-2.jpg"),
      },
      {
        id: 3,
        label: "Home Appliances",
        imageUrl: require("../assets/images/header_icons/menu-3.jpg"),
      },
      {
        id: 4,
        label: "Repair",
        imageUrl: require("../assets/images/header_icons/menu-4.jpg"),
      },
      {
        id: 5,
        label: "Carpenter",
        imageUrl: require("../assets/images/header_icons/menu-5.jpg"),
      },
      {
        id: 6,
        label: "Grooming",
        imageUrl: require("../assets/images/header_icons/menu-6.jpg"),
      },
      {
        id: 7,
        label: "Electronics",
        imageUrl: require("../assets/images/header_icons/menu-7.png"),
      },
      {
        id: 8,
        label: "Travel",
        imageUrl: require("../assets/images/header_icons/menu-8.jpg"),
      },
      {
        id: 9,
        label: "Vegetables",
        imageUrl: require("../assets/images/header_icons/menu-9.jpg"),
      },
      {
        id: 10,
        label: "Grocery",
        imageUrl: require("../assets/images/header_icons/menu-10.jpg"),
      },
      {
        id: 11,
        label: "Self jobs",
        imageUrl: require("../assets/images/header_icons/menu-11.jpg"),
      },
      {
        id: 12,
        label: "Vehicle care",
        imageUrl: require("../assets/images/header_icons/menu-12.jpg"),
      },
      {
        id: 13,
        label: "Food",
        imageUrl: require("../assets/images/header_icons/menu-13.jpg"),
      },
      {
        id: 14,
        label: "RO services",
        imageUrl: require("../assets/images/header_icons/menu-14.jpg"),
      },
    ],
  },
  {
    id: "showBusinessEssential",
    label: "Business Home",
    items: [
      {
        id: 191,
        label: "Ad services",
        imageUrl:
          "https://img.icons8.com/color/96/megaphone.png",
        subItems: [
          {
            id: 1,
            label: "Subcategory 1",
            imageUrl: "subimage_url_1",
          },
          {
            id: 2,
            label: "Subcategory 2",
            imageUrl: "subimage_url_2",
          },
        ],
      },
      {
        id: 212,
        label: "Animal Feed & Care",
        imageUrl:
          "https://img.icons8.com/color/96/pet-food.png",
        subItems: [
          {
            id: 1,
            label: "Subcategory 1",
            imageUrl: "subimage_url_1",
          },
          {
            id: 2,
            label: "Subcategory 2",
            imageUrl: "subimage_url_2",
          },
        ],
      },
      {
        id: 217,
        label: "Artificial limbs Supplier",
        imageUrl:
          "https://img.icons8.com/color/96/bionic-leg.png",
      },
    ],
  },
  {
    id: "showTools",
    label: "Tools",
    items: [
      {
        id: "Hot offers",
        label: "Hot offers",
        imageUrl: require("../assets/images/tool_icons/localoffer.png"),

        subItems: [
          // Sub-items for the Tools category
          {
            id: "subItem1",
            label: "baba DJ sound belwaniya bazaar m.9113137400",
            date: "2024-02-26 14:16:21",
            bgClass: "bg0",
            style: {
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              display: "inline-block",
              position: "absolute",
              left: "7px",
              top: "2px",
            },
          },
          {
            id: "subItem2",
            label:
              "हमारे यहाँ सभी कंपनी का मोबाइल बनाया जाता हैं और सभी कंपनी का मोबाइल का एक्सेसरीस मोबाइल फ़ोन उपलब्ध हैं पता स्टेशन रोड पांच मुखी हनुमान मंदिर के पास मोबाइल न. 7050998627",
            date: "2024-02-26 09:00:53",
            bgClass: "bg1",
            style: {
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              display: "inline-block",
              position: "absolute",
              left: "7px",
              top: "2px",
            },
          },
          {
            id: "subItem3",
            label:
              "sanjay mistri chulla, kukar,miksar home sarvice repar stesaon rod aarha m-8210789047",
            date: "2024-02-26 08:44:49",
            bgClass: "bg2",
            style: {
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              display: "inline-block",
              position: "absolute",
              left: "7px",
              top: "2px",
            },
          },
          {
            id: "subItem4",
            label:
              "mobile repairing and its gift Store arha Pakdi rod m. 6378262825",
            date: "2024-02-26 07:46:54",
            bgClass: "bg3",
            style: {
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              display: "inline-block",
              position: "absolute",
              left: "7px",
              top: "2px",
            },
          },
          // Add more sub-items as needed
        ],
      },
      {
        id: "Queries",
        label: "Queries",
        imageUrl: require("../assets/images/tool_icons/question-mark.png"),
      },
      {
        id: "Local jobs",
        label: "Local jobs",
        imageUrl: require("../assets/images/tool_icons/localjob.png"),
        subItems: [
          {
            id: "job1",
            label:
              "Urgent hiring for 10 persons in Bangalore: For Crew coach & Outlet Managers. Contact: +91-6366716922",
            date: "2024-02-16 13:02:07",
            bgClass: "bg0",
          },
          {
            id: "job2",
            label:
              "Wanted immediately Male/Female for job in Bangalore of Loader, Picker, Packer, Front office. Take home salary Rs.25000. Call at 9113618874, 9844019555, 9036111429",
            date: "2024-02-10 03:54:03",
            bgClass: "bg1",
          },
          {
            id: "job3",
            label:
              "Urgent hiring for Housekeeping, Electrician, Supervisor, Security guards in Bangalore. call 8826194299, 7217833942.",
            date: "2023-11-23 16:07:53",
            bgClass: "bg2",
          },
          // Add more job items as needed
        ],
      },
      {
        id: "Shared Trips",
        label: "Shared Trips",
        imageUrl: require("../assets/images/tool_icons/shared_trip.png"),
      },
      {
        id: "Send Whatsapp",
        label: "Send Whatsapp",
        imageUrl: require("../assets/images/tool_icons/whatsapp.png"),
      },
      {
        id: "Buy in Local",
        label: "Buy in Local",
        imageUrl: require("../assets/images/tool_icons/buy.png"),
      },
      {
        id: "Sell in Local",
        label: "Sell in Local",
        imageUrl: require("../assets/images/tool_icons/sell.png"),
        subItems: [
          {
            id: "subItem1",
            label:
              "ट्रस्ट ऐप के लिए अपने लोकल एरिया में ही काम करना चाहते है ? ऐप के Contact Support से मैसेज भेजे। Want to work for Trust app in your local area ? Send message from Contact Support.",
            date: "2023-06-19 14:45:56",
            bgClass: "bg0",
          },
          {
            id: "subItem2",
            label:
              "Get veggies & Fruits at lowest price in Bellandur. Home delivery even for Rs.50 orders.",
            date: "2023-06-09 03:16:43",
            bgClass: "bg1",
          },
          {
            id: "subItem3",
            label:
              "ऐप का यूट्यूब देखने के लिए ऐप के होम पेज पे सबसे नीचे में (?) बटन को क्लिक कर अगले पेज पे यूट्यूब लिंक को क्लिक करे। ऐप के वेबसाइट  www.TrustApp.in  से भी यूट्यूब पे जा सकते है।",
            date: "2023-05-21 08:43:14",
            bgClass: "bg2",
          },
          {
            id: "subItem4",
            label:
              "लॉगिन करने के बाद सबसे दाए तरफ नोटिफिकेशन घंटी के बगल में पीला बटन क्लिक करे होम पेज पे जाने के लिए। सप्ताह में तीन बार होम पेज विजिट करने से आपको ज्यादा ऑफर मिलता है।&nbsp;",
            date: "2023-04-22 14:01:30",
            bgClass: "bg3",
          },
          {
            id: "subItem5",
            label:
              "अपने ही एरिया में ट्रस्ट ऐप के लिए काम करे और अच्छा पैसा कमाएं। काम करने के लिए ऐप अच्छी तरह से आना चाहिए। कॉन्टकैट करने के लिए Contcat Support को क्लिक कर मेसेज भेजे , आपको कॉल किया जायेगा।",
            date: "2023-04-20 02:45:45",
            bgClass: "bg4",
          },
          {
            id: "subItem6",
            label:
              "Rs.12 / km के रेट से অটো भाड़ा के लिए बुक करे। बुकिंग Tools --&gt; Any Trip या Any Delivery से करे। किसी तरह के हेल्प के लिए Contact Support से मेसेज भेजे या  ऐप का यूट्यूब www.TrustApp.in पे जाके देखे।",
            date: "2023-04-17 16:20:43",
            bgClass: "bg5",
          },
        ],
      },
      // Add more items as needed
    ],
  },
];

// Define getColorForTool function
const getColorForTool = (label) => {
  switch (label) {
    case "Hot offers":
      return "#357EC7";
    case "Queries":
      return "#F1C40F";
    case "Local jobs":
      return "#FF5733";
    case "Shared Trips":
      return "#008000";
    case "Send Whatsapp":
      return "#008000";
    case "Buy in Local":
      return "#a4c639";
    case "Sell in Local":
      return "#6495ED";
    default:
      return "#f0f0f0";
  }
};

// Define checkDivSection function
const checkDivSection = (divId) => {
  // Implement functionality to handle div section
};

// Define popUpMultipleImages function
const popUpMultipleImages = (element) => {
  // Implement functionality to handle multiple images popup
};

// Define singleProviderDetailsPage function
const singleProviderDetailsPage = (element) => {
  // Implement functionality to handle provider details page
};

// Define phoneForm function
const phoneForm = (element) => {
  // Implement functionality to handle phone form
};

// Define BoxImageSection component
const BoxImageSection = () => {
  // Define state variables
  const [activeCategory, setActiveCategory] = useState("showEssential");
  const [showDiv1, setShowDiv1] = useState(true);
  const [showDiv2, setShowDiv2] = useState(false);
    const [showDiv3, setShowDiv3] = useState(false);
  const [showDiv4, setShowDiv4] = useState(false);
  const [showDiv7, setShowDiv7] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showMobileVersionDialog, setShowMobileVersionDialog] = useState(false);
  const [selectedSubItems, setSelectedSubItems] = useState([]);

  const [selectedSubItemId, setSelectedSubItemId] = useState(null);



  

  // Define event handling functions
  const handleCategoryChange = (category) => {
    setShowMobileVersionDialog(true);
  };

  const handleCategoryClick = (item) => {
    if (activeCategory === "showEssential") {
      setShowMobileVersionDialog(true);
      return;
    }

    if (item.label === "Send Whatsapp") {
      setShowModal(true);
    } else {
      setShowDiv1(false);
      setShowDiv2(true);
      selectTool(item.id);
    }
  };

  const handleRadioButtonClick = (subItemId) => {
    setSelectedSubItemId(subItemId);
    setShowDiv1(false);
    setShowDiv2(false);
    setShowDiv3(true);
  };

  
  const handlefilterButtonClick = () => {
    // setSelectedSubItemId(subItemId);
    // setShowDiv1(false);
    setShowDiv3(false);
    setShowDiv4(true);
  };


  const handleBackButtonClick = () => {
    setShowDiv2(true);
    setShowDiv4(false);
  };

  const getActiveCategoryLabel = () => {
    const activeCategoryItem = categoryData.find(
      (category) => category.id === activeCategory
    );
    if (
      activeCategoryItem &&
      activeCategoryItem.items &&
      activeCategoryItem.items.length > 0
    ) {
      return activeCategoryItem.items[0].label;
    } else {
      return "";
    }
  };


  const renderCategoryItems = (items) => {
    return (
      <ul className="catelist">
        {items.map((item) => (
          <li
            key={item.id}
            className="pg"
            onClick={() => handleCategoryClick(item)}
            data-name={item.label}
          >
            <img src={item.imageUrl} alt={item.label} />
            <p>{item.label}</p>
          </li>
        ))}
      </ul>
    );
  };

  const selectTool = (itemId) => {
    const selectedItem = categoryData
      .find((category) => activeCategory === category.id)
      .items.find((item) => item.id === itemId);

    setSelectedSubItems(selectedItem.subItems || []);

    setShowDiv1(false);
    setShowDiv2(true);
  };

  return (
    <>
      {
        <section className="premium-home-container">
          <div className="container-fluid px-lg-5">
            <div className="row align-items-stretch">
              {/* LEFT COLUMN - Feature Cards */}
              <div className="col-xl-4 col-lg-3 col-md-3">
                <div className="enterprise-card">
                  <h3>Visit job list & Earn cash rewards in Trust app.</h3>
                  <p>
                    At the bottom section of the Trust app's Home page, click
                    the 🚀 button, then on the next page, click "Local job" to
                    view the latest jobs posted directly by shops and businesses. Follow this{" "}
                    <a
                      href="https://youtu.be/B28z7d9vlkk?si=fkJ3zErPF5Moeuwu"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#ea3c53", textDecoration: "underline", fontWeight: "600" }}
                    >
                      Video
                    </a>{" "}
                    for detailed steps.
                  </p>
                </div>

                <div className="enterprise-card">
                  <h3>Get more customers for your business</h3>
                  <p>
                    Create a service provider profile in the app to receive
                    direct orders from your customers. Follow this{" "}
                    <a
                      href="https://youtu.be/0gPIDlOpyNY?si=3x2TwvOcvHmz5I1t"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#ea3c53", textDecoration: "underline", fontWeight: "600" }}
                    >
                      Video
                    </a>{" "}
                    for detailed steps.
                  </p>
                </div>
              </div>

              {/* MIDDLE COLUMN - Interactive simulated mobile phone */}
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="simulated-phone-container">
                  <div className="phone-mock-frame">
                    <div className="phone-screen-content">
                  <div className="ajax-loader">
                    <img
                      src={require("../assets/images/loader1.gif")}
                      className="img-responsive"
                      alt="Loader"
                    />
                  </div>
                  <div
                    className="div1"
                    style={{ display: showDiv1 ? "block" : "none" }}
                  >
                    <div className="searchbox1">
                      <label>One app for all businesses</label>
                    </div>
                    <div className="premium-switch-tabs">
                      {categoryData.map((category) => (
                        <button
                          key={category.id}
                          className={`premium-switch-tab-item ${activeCategory === category.id ? "active" : ""}`}
                          onClick={handleCategoryChange}
                        >
                          {category.label}
                        </button>
                      ))}
                    </div>
                    <Dialog
                      open={showMobileVersionDialog}
                      onClose={() => setShowMobileVersionDialog(false)}
                      aria-labelledby="mobile-version-dialog-title"
                    PaperProps={{
                      sx: {
                        borderRadius: "30px",
                        maxWidth: "max-content",
                        overflow: "hidden",
                        boxShadow: "0 6px 16px rgba(234, 60, 83, 0.25)",
                      },
                    }}
                    >
                    <DialogContent
                      id="mobile-version-dialog-title"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75,
                        px: 1.75,
                        py: 1,
                        color: "#ffffff",
                        background:
                          "linear-gradient(135deg, #ea3c53 0%, #ff5a79 100%)",
                        fontSize: "11px",
                        fontWeight: 700,
                        letterSpacing: "0.5px",
                      }}
                    >
                      <span>use mobile app version</span>
                      <IconButton
                        aria-label="Close mobile version message"
                        onClick={() => setShowMobileVersionDialog(false)}
                        size="small"
                        sx={{
                          color: "#ffffff",
                          backgroundColor: "rgba(255, 255, 255, 0.16)",
                          "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.28)",
                          },
                        }}
                      >
                        ×
                      </IconButton>
                      </DialogContent>
                    </Dialog>

                    {categoryData.map((category) => (
                      <React.Fragment key={category.id}>
                        <ul
                          className="premium-phone-cat-grid"
                          id={category.id}
                          style={{
                            display:
                              activeCategory === category.id ? "grid" : "none",
                          }}
                        >
                          {category.items.map((item) => (
                            <li
                              key={item.id}
                              className="premium-phone-cat-item"
                              onClick={() => handleCategoryClick(item)}
                              data-name={item.label}
                            >
                              <img src={item.imageUrl} alt="" />
                              <p>{item.label}</p>
                            </li>
                          ))}
                        </ul>
                        {category.id === 'showEssential' && activeCategory === 'showEssential' && (
                          <div style={{ textAlign: 'center', width: '100%', padding: '10px', marginTop: '12px' }}>
                            <b style={{ color: '#dc2626', fontSize: '0.7rem' }}>Our app supports 400 service categories, but only a demo is shown here. Please use the mobile version for the full list.</b>
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                  {showModal && (
                    <WhatsAppModal
                      show={showModal}
                      onHide={() => setShowModal(false)}
                      containerClassName="div1"
                    />
                  )}
                  <div
                    className="div2"
                    style={{ display: showDiv2 ? "block" : "none" }}
                  >
                    {activeCategory !== "showTools" && (
                      <div className="searchbox1">
                        <label>Bid & get services</label>
                      </div>
                    )}
                    {activeCategory === "showTools" && (
                      <div
                        className="searchbox"
                        style={{ justifyContent: "space-around" }}
                      >
                        <div className="row no-gutters">
                          <div className="col-5">
                            <select
                              className="form-control select2 select2-hidden-accessible"
                              data-select2-id="1"
                              tabIndex="-1"
                              aria-hidden="true"
                            >
                              <option data-select2-id="3">
                                Search by City
                              </option>
                              <option
                                value="147948"
                                data-lat="11.93911700"
                                data-lng="79.48715900"
                              >
                                Villupuram
                              </option>
                            </select>
                            <span
                              className="select2 select2-container select2-container--default"
                              dir="ltr"
                              data-select2-id="2"
                              style={{ width: "auto" }}
                            >
                              <span className="selection">
                                <span
                                  className="select2-selection select2-selection--single"
                                  role="combobox"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  tabIndex="0"
                                  aria-labelledby="select2-wdty-container"
                                >
                                  <span
                                    className="select2-selection__rendered"
                                    id="select2-wdty-container"
                                    role="textbox"
                                    aria-readonly="true"
                                    title="Bangalore"
                                  >
                                    Bangalore
                                  </span>
                                  <span
                                    className="select2-selection__arrow"
                                    role="presentation"
                                  >
                                    <b role="presentation"></b>
                                  </span>
                                </span>
                              </span>
                              <span
                                className="dropdown-wrapper"
                                aria-hidden="true"
                              ></span>
                            </span>
                          </div>

                          <div className="col-1">
                            <label>OR</label>
                          </div>

                          <div className="col-6 text-center">
                            <button
                              className="text-center btn btn-warning"
                              style={{
                                fontSize: "14px",
                                height: "34px",
                                backgroundColor: "#ffc107",
                              }}
                            >
                              Live Location
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    <button
                      className="backbtn"
                      onClick={() => {
                        setShowDiv1(true);
                        setShowDiv2(false);
                        setSelectedSubItemId(""); // Clear selected sub item
                      }}
                    >
                      <i className="fas fa-arrow-left"></i>
                    </button>
                    <span className="div4-sub-cat-name">
                      <strong id="category_name">
                        {getActiveCategoryLabel()}
                      </strong>
                    </span>
                    <span id="showpropertytypes">
                      {selectedSubItems.length > 0 ? (
                        selectedSubItems.map((subItem) => (
                          <div key={subItem.id}>
                            {activeCategory === "showTools" ? (
                              <ul
                                className="joblist"
                                style={{ marginTop: "20px" }}
                              >
                                <li
                                  id={`radio-${subItem.id}`}
                                  name="subItemRadio"
                                >
                                  <small className={subItem.bgClass}></small>
                                  <p
                                    onClick={() =>
                                      handleRadioButtonClick(subItem.id)
                                    }
                                  >
                                    <i>&nbsp;</i>
                                    {subItem.label}
                                  </p>
                                  <aside>
                                    <span>2024-02-26 14:16:21</span>
                                  </aside>
                                </li>
                              </ul>
                            ) : (
                              <div>
                                <input
                                  type="radio"
                                  id={`radio-${subItem.id}`}
                                  name="subItemRadio"
                                  value={subItem.id}
                                  checked={selectedSubItemId === subItem.id}
                                  onChange={() =>
                                    handleRadioButtonClick(subItem.id)
                                  }
                                  control={<Radio color="info" />}
                                  style={{
                                    marginTop: "20px",
                                    marginLeft: "15px",
                                    marginRight: "15px",
                                    borderColor: "#ea3c53",
                                  }}
                                />
                                <small className="bg0"></small>
                                <label
                                  htmlFor={`radio-${subItem.id}`}
                                  style={{ fontWeight: "600", color: "black" }} // Adjust label boldness and color
                                >
                                  {subItem.label}
                                </label>
                              </div>
                            )}
                          </div>
                        ))
                      ) : (
                        <div>Data Not Available!</div>
                      )}
                    </span>
                    {activeCategory !== "showTools" && (
                      <p style={{ color: "#3197EE", marginTop: "50px" }}>
                        <strong>
                          Need more category or sub-categories suitable for your
                          profession? Click Help (?) button on Home Page to
                          contact Trust Support.
                        </strong>
                      </p>
                    )}
                  </div>

                  <WhatsAppModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                  />

                  <div
                    className="div3"
                    style={{ display: showDiv3 ? "block" : "none" }}
                  >
                    <div className="searchbox1">
                      <label>Bid & get services</label>
                    </div>

                    <button
                      className="backbtn"
                      onClick={() => {
                        setShowDiv2(true);
                        setShowDiv3(false);
                      }}
                    >
                      <i className="fas fa-arrow-left"></i>
                    </button>
                    <span className="div4-sub-cat-name">
                      <strong id="cat_name">Filter</strong>
                    </span>
                    <div className="support">
                      <span id="filter_name">
                        <div>
                          <span>
                            <a
                              href="#"
                              onClick={() => handlefilterButtonClick()}
                            >
                              # Gas
                            </a>
                          </span>
                        </div>
                        <p>
                          <strong>
                            Need more category or sub-categories suitable for
                            your profession? Click Help (?) button on Home Page
                            to contact Trust Support.
                          </strong>
                        </p>
                      </span>
                    </div>
                  </div>

                  <div
                    className="div4"
                    style={{ display: showDiv4 ? "block" : "none" }}
                  >
                    <div
                      className="searchbox"
                      style={{ justifyContent: "space-around" }}
                    >
                      <div className="row no-gutters">
                        <div className="col-5">
                          <select
                            className="form-control select2 select2-hidden-accessible"
                            data-select2-id="1"
                            tabIndex="-1"
                            aria-hidden="true"
                          >
                            <option data-select2-id="3">Search by City</option>
                            <option
                              value="147948"
                              data-lat="11.93911700"
                              data-lng="79.48715900"
                            >
                              Villupuram
                            </option>
                          </select>
                          <span
                            className="select2 select2-container select2-container--default"
                            dir="ltr"
                            data-select2-id="2"
                            style={{ width: "auto" }}
                          >
                            <span className="selection">
                              <span
                                className="select2-selection select2-selection--single"
                                role="combobox"
                                aria-haspopup="true"
                                aria-expanded="false"
                                tabIndex="0"
                                aria-labelledby="select2-wdty-container"
                              >
                                <span
                                  className="select2-selection__rendered"
                                  id="select2-wdty-container"
                                  role="textbox"
                                  aria-readonly="true"
                                  title="Bangalore"
                                >
                                  Bangalore
                                </span>
                                <span
                                  className="select2-selection__arrow"
                                  role="presentation"
                                >
                                  <b role="presentation"></b>
                                </span>
                              </span>
                            </span>
                            <span
                              className="dropdown-wrapper"
                              aria-hidden="true"
                            ></span>
                          </span>
                        </div>

                        <div className="col-1">
                          <label>OR</label>
                        </div>

                        <div className="col-6 text-center">
                          <button
                            className="text-center btn btn-warning"
                            style={{
                              fontSize: "14px",
                              height: "34px",
                              backgroundColor: "#ffc107",
                            }}
                          >
                            Live Location
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="btndiv">
                      {/* <button className="backbtn" value="1">
                      <i className="fas fa-arrow-left"></i>
                    </button> */}
                      <button
                        className="backbtn"
                        onClick={() => {
                          setShowDiv3(true);
                          setShowDiv4(false);
                        }}
                      >
                        <i className="fas fa-arrow-left"></i>
                      </button>
                      <img
                        src="https://trustapp.in/public/images/icons/icon_map.png"
                        style={{
                          width: "25px",
                          height: "25px",
                          cursor: "pointer",
                        }}
                        className="mapbtn"
                        onClick={() => checkDivSection("mapdiv")}
                      />
                    </div>
                    <div className="course_sidebar">
                      <span className="div4-sub-cat-name">
                        <img
                          src="https://trustserv.org/trustapp/category_images/1591021454.png"
                          className="provider_icons"
                          id="cat_img"
                        />
                        <strong id="cat_name">Block level govt contacts</strong>
                      </span>
                      <ul id="provider_details">
                        <li>
                          <div className="sidecourse_thumb">
                            <a
                              onClick={() => popUpMultipleImages(this)}
                              data-image="1588049637IMG_20200407_125107_2002022088.jpg"
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                src="https://trustserv.org/trustapp/user_image/1588049637IMG_20200407_125107_2002022088.jpg"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src =
                                    "https://trustapp.in/public/images/default.png";
                                }}
                              />
                            </a>
                          </div>
                          <div className="sidecourse_content">
                            <h5>
                              <a href="">Hardik IDEA</a>
                            </h5>
                            <div className="icondiv">
                              <img
                                src="https://trustapp.in/public/images/icons/icon_star_4.PNG"
                                className="provider_icons"
                                style={{ cursor: "pointer" }}
                                data-provider_id="1947"
                                data-name="Hardik IDEA"
                                data-address="GJ SH 7, Panchavati Society, Dhrangadhra, Gujarat 363310, India"
                                data-business="My Business Description"
                                data-div6bckbtn="2"
                                onClick={() => singleProviderDetailsPage(this)}
                              />
                              <a
                                href="https://www.google.com/maps/?q=22.9976388,71.4528948"
                                target="#"
                                className="loaction"
                              >
                                <img
                                  src="https://trustapp.in/public/images/icons/icon_map.png"
                                  className="provider_icons"
                                />
                                <span>1286.36 km</span>
                              </a>
                              <a href="#">
                                <i
                                  className="far fa-envelope"
                                  onClick={() => phoneForm(this)}
                                  data-spmoblie="+919377177126"
                                ></i>
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <div className="vgri_guarnt">
                        <span className="Verified">
                          <i className="fas fa-badge-check"></i> Verified
                        </span>
                        <span className="Guarantee">
                          <i className="fas fa-star"></i> 100% Guarantee
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="div7"
                    style={{ display: showDiv7 ? "block" : "none" }}
                  >
                    <div
                      className="searchbox"
                      style={{ justifyContent: "space-around" }}
                    >
                      <div className="row no-gutters">
                        <div className="col-5">
                          <select
                            className="form-control select2 select2-hidden-accessible"
                            data-select2-id="1"
                            tabIndex="-1"
                            aria-hidden="true"
                          >
                            <option data-select2-id="3">Search by City</option>
                            <option
                              value="147948"
                              data-lat="11.93911700"
                              data-lng="79.48715900"
                            >
                              Villupuram
                            </option>
                          </select>
                          <span
                            className="select2 select2-container select2-container--default"
                            dir="ltr"
                            data-select2-id="2"
                            style={{ width: "auto" }}
                          >
                            <span className="selection">
                              <span
                                className="select2-selection select2-selection--single"
                                role="combobox"
                                aria-haspopup="true"
                                aria-expanded="false"
                                tabIndex="0"
                                aria-labelledby="select2-wdty-container"
                              >
                                <span
                                  className="select2-selection__rendered"
                                  id="select2-wdty-container"
                                  role="textbox"
                                  aria-readonly="true"
                                  title="Bangalore"
                                >
                                  Bangalore
                                </span>
                                <span
                                  className="select2-selection__arrow"
                                  role="presentation"
                                >
                                  <b role="presentation"></b>
                                </span>
                              </span>
                            </span>
                            <span
                              className="dropdown-wrapper"
                              aria-hidden="true"
                            ></span>
                          </span>
                        </div>

                        <div className="col-1">
                          <label>OR</label>
                        </div>

                        <div className="col-6 text-center">
                          <button
                            className="text-center btn btn-warning"
                            style={{
                              fontSize: "14px",
                              height: "34px",
                              backgroundColor: "#ffc107",
                            }}
                          >
                            Live Location
                          </button>
                        </div>
                      </div>
                    </div>
                    <button
                      className="backbtn"
                      onClick={() => setShowDiv7(false)}
                    >
                      <i className="fas fa-arrow-left"></i>
                    </button>
                    <span>
                      <strong id="toolTitle">Hot offers</strong>
                    </span>
                    <span id="shared_trips">
                      <ul
                        className="joblist"
                        style={{ marginTop: "15px" }}
                        id="joblist"
                      >
                        {/* Render selected sub-items as list items */}
                        {selectedSubItems.map((subItem) => (
                          <li key={subItem.id}>
                            <small className="bg0"></small>
                            <p>
                              <i>&nbsp;</i>
                              {subItem.label}
                            </p>
                          </li>
                        ))}
                      </ul>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

              {/* RIGHT COLUMN - Feature Cards */}
              <div className="col-xl-4 col-lg-3 col-md-3">
                <div className="enterprise-card">
                  <h3>Hire, search for local jobs, Buy, and Sell locally</h3>
                  <p>
                    Every broadcast is FREE! Post your Buy and Sell of old
                    goods, hire staff for your shop, and search for local jobs.
                    Log into the app and click Tools then Broadcast.{" "}
                    <a
                      href="https://youtu.be/mxf_tNF_4F0?si=J37UdgtxYZ8VQBI3"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#ea3c53", textDecoration: "underline", fontWeight: "600" }}
                    >
                      Video
                    </a>
                  </p>
                </div>

                <div className="enterprise-card">
                  <h3>Broadcast any AD at ZERO cost</h3>
                  <p>
                    Advertise your events, sales, or anything at ZERO cost. For
                    detailed steps, view this{" "}
                    <a
                      href="https://www.youtube.com/playlist?list=PLGPpgDt6rdY99nCCp3eSSMCpYtSS7ZiwE"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#ea3c53", textDecoration: "underline", fontWeight: "600" }}
                    >
                      Video
                    </a>
                    .
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>
      }
    </>
  );
};

export default BoxImageSection;
